import cx from "classnames";
import React, { Fragment, memo, useContext, useEffect, useState } from "react";

// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { Doctor, ICON_MINUS_SRC } from "../../../resources/Assets";
import {
  AfterMealInputLayer,
  AlertPopup,
  Container,
  DateLayer,
  DateTimeLayer,
  DeviceBsBuyLayer,
  DeviceInputLayer,
  InsulinLayer,
  WeekTimeLayer,
  closeLayerFn,
  openAlertPopup,
  openLayerFn,
  pickerOnInsFn,
  pickerOneEndInsFn,
  pickerStartFn2,
  pickerStartInsFn
} from "../../Layout";

// Temp Images
import _ICON_MINUS from "../../../resources/images/icon/icon_minus_circle_min.png";
import _ICON_PLUS from "../../../resources/images/icon/icon_plus_circle_min.png";
import _INSULIN_GUIDE from "../../../resources/images/sub/insulin_guide_illust.jpg";
import _T_MEAL from "../../../resources/images/user/user_meal_photo01.jpg";

import { SUBS, SubMenu } from "./History";

import { addDays, addMonths, format } from "date-fns";
import { useInView } from "react-intersection-observer";
import AutoBs from "../../../components/AD/AutoBs";
import {
  PostApi1201,
  PostApi1202,
  PostApi1205,
  PostApi1206,
  PostApi1207,
  PostApi1208,
  PostApi1209,
  PostApi1212,
  PostApi1215,
  PostApi999,
} from "../../../modules/network/padoPost";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { PeriodTypeChange, convertFormat } from "../../../modules/utils/PeriodTypeChange";
import { userHabit } from "../../../modules/utils/UserHabit";
import { reLogin } from "../../common/AutoLogin/AutoLogin";
import { AfterMealInputLayer2 } from "../../common/Layer/AfterMealInputLayer2";
import DvcInputLayer from "../../common/Layer/DvcInputLayer";
import { LayerBox } from "../../common/Layer/LayerBox";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import BsHistList, { IslnHistList } from "./BsHistList";
import InputInsulin from "./InputInsulin";
import ModifyLayer from "./ModifyLayer";
import TargetBs from "./TargetBs";
import useTitle from "../../../modules/hooks/useTitle";
const interfaceDateFormat = "yyyyMMdd";

const TYPE1 = [
  { code: "BLOODSUGAR", label: "혈당입력" },
  { code: "INSULIN", label: "인슐린 입력" },
];
const TYPE2 = [
  { code: "MANUAL", label: "수동입력" },
  { code: "AUTOMATIC", label: "자동입력" },
];

const sub = SUBS[0];

export default props => {
  useTitle("자가건강관리_혈당_입력");
  // 9월 28일 화 오전 08:50

  // 현재 날짜 시간 기본설정
  // let toDay = new Date();
  const [toDay, setToDay] = useState(new Date());
  //요일 설정
  const week = new Array("일", "월", "화", "수", "목", "금", "토");

  let defaultYear = toDay.getFullYear();
  let defaultMonth = toDay.getMonth() + 1;
  let defaultDate = toDay.getDate();

  let defaultHours = toDay.getHours();
  let defaultMin = toDay.getMinutes();

  let defaultDay = week[toDay.getDay()];
  let defaultAmPm;

  if (defaultMonth < 10) {
    defaultMonth = "0" + defaultMonth;
  }

  if (defaultDate < 10) {
    defaultDate = "0" + defaultDate;
  }

  if (defaultHours < 10) {
    defaultHours = "0" + defaultHours;
  }

  if (defaultMin < 10) {
    defaultMin = "0" + defaultMin;
  }

  if (defaultHours < 12) {
    defaultAmPm = "오전";
  } else {
    defaultAmPm = "오후";
  }
  let defaultValue =
    defaultMonth +
    "월" +
    " " +
    defaultDate +
    "일" +
    " " +
    defaultDay +
    " " +
    defaultAmPm +
    " " +
    defaultHours +
    ":" +
    defaultMin;

  const [changeCount, setChangeCount] = useState(0);
  const [type1, setType1] = useState(TYPE1[0].code);
  const [type2, setType2] = useState(TYPE2[0].code);

  const [bsDate, setBsDate] = useState(
    defaultYear + "" + defaultMonth + "" + defaultDate
  );
  const [bsTime, setBsTime] = useState(defaultHours + "" + defaultMin);
  const [afMealTime, setAfMealTime] = useState("");

  // 인터페이스 필요 파라미터
  const { userinfo, cfg, phonecfg, dispatch, appStdInfo } =
    useContext(AppContext);
  const [inptType, setInptType] = useState("M");
  const [mealType, setMealType] = useState("B");
  const [dvcNm, setDvcNm] = useState("");
  const [bs, setBs] = useState("");
  const [bsMemo, setBsMemo] = useState("");

  const [injctForm, setInjctForm] = useState("01");
  const [injctDose, setInjctDose] = useState("1");
  const [injctFormCstm, setInjctFormCstm] = useState("99");
  const [injctDoseCstm, setInjctDoseCstm] = useState("1");

  const [injctMemo, setInjctMemo] = useState("");
  const [injctFormDesc, setInjctFormDesc] = useState("");

  const [inputMode, setInputMode] = useState("CUSTOM");
  const [connection, setConnection] = useState(false);
  const [getData, setGetData] = useState();
  const [deviceState, setDeviceState] = useState();
  const [inputCnt, setInputCnt] = useState(1);

  const [isBuyBsDisplay, setIsBuyBsDisplay] = useState(false);
  const [display, setDisplay] = useState(false);
  const [dvcTitle, setDvcTitle] = useState("");

  const request1201 = (
    userinfo,
    cfg,
    inptType,
    bsDate,
    bsTime,
    mealType,
    afMealTime,
    bs,
    dvcNm,
    bsMemo
  ) => {
    // 날짜/시간 선택 유무 체크
    if (bsDate != "") {
      PostApi1201(
        userinfo,
        cfg,
        phonecfg,
        inptType,
        bsDate,
        bsTime,
        mealType,
        afMealTime,
        bs,
        dvcNm,
        bsMemo
      )
        .then(res => {
          // 결과 성공시 페이지 초기화 (계속 등록할지, 페이지 이동할지)
          if (res.resultMsg === "SUCCESS") {
            //주치의 메세지 띄우기 (조건에 맞으면)
            openLayerFn($(".doctor-message-layer"));
          } else {
            openAlertPopup("등록실패");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      openAlertPopup("측정 날짜/시간을 선택해 주십시오.");
    }
  };

  const request1202 = (
    userinfo,
    cfg,
    phonecfg,
    injctDate,
    injctTime,
    mealType,
    afMealTime,
    injctForm,
    injctDose,
    injctMemo,
    injctFormDesc
  ) => {
    // 날짜/시간 선택 유무 체크
    if (bsDate != "") {
      PostApi1202(
        userinfo,
        cfg,
        phonecfg,
        injctDate,
        injctTime,
        mealType,
        afMealTime,
        injctForm,
        injctDose,
        injctMemo,
        injctFormDesc
      )
        .then(res => {
          // 결과 성공시 페이지 초기화 (계속 등록할지, 페이지 이동할지)
          if (res.resultMsg === "SUCCESS") {
            //주치의 메세지 띄우기 (조건에 맞으면)
            openLayerFn($(".doctor-message-layer"));
          } else {
            openAlertPopup("등록실패");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      openAlertPopup("측정 날짜/시간을 선택해 주십시오.");
    }
  };

  const saveBs = () => {
    // 필수 값
    if (bsDate === "") {
      openAlertPopup("날짜/시간을 선택해주세요.");
      return;
    }
    if (bsTime === "") {
      openAlertPopup("날짜/시간을 선택해주세요.");
      return;
    }
    if (mealType === "A") {
      if (afMealTime === "") {
        openAlertPopup("식사 후 몇시간인지 선택해주세요.");
        return;
      }
    }
    if (bs === "") {
      openAlertPopup("측정한 혈당값을 넣어주세요.");
      return;
    }

    // 혈당 최소~최대 10~600
    if (bs <= appStdInfo.bsMin || bs >= appStdInfo.bsMax) {
      openAlertPopup(
        "혈당수치는 " +
          appStdInfo.bsMin +
          "~" +
          appStdInfo.bsMax +
          "사이의 값을 넣으셔야 합니다."
      );
      return;
    }

    request1201(
      userinfo,
      cfg,
      inptType,
      bsDate,
      bsTime,
      mealType,
      afMealTime,
      bs,
      dvcNm,
      bsMemo
    );
  };

  const saveInjct = () => {
    // injctFormCstm Array
    let ijctNameArray = new Array();
    let ijctDoseArray = new Array();
    let injctFormArray = new Array();

    $("input[name=injctName]").each(function (idx, content) {
      if ($(content).val() != "") {
        ijctNameArray.push($(content).val());
        injctFormArray.push(99);
      }
    });

    $("input[name=injctDose]").each(function (idx, content) {
      if ($(content).val() != "") {
        ijctDoseArray.push($(content).val());
      }
    });

    if (ijctNameArray.length == ijctDoseArray.length) {
      request1202(
        userinfo,
        cfg,
        phonecfg,
        bsDate,
        bsTime,
        mealType,
        afMealTime,
        injctFormArray,
        ijctDoseArray,
        injctMemo,
        ijctNameArray
      );
    } else {
      alert("입력한 값을 확인하세요.");
    }
  };

  const checkValue = () => {
    // 필수 값
    if (bsDate === "") {
      openAlertPopup("날짜/시간을 선택해주세요.");
      return;
    }
    if (bsTime === "") {
      openAlertPopup("날짜/시간을 선택해주세요.");
      return;
    }
    if (mealType === "A") {
      if (afMealTime === "") {
        openAlertPopup("식사 후 몇시간인지 선택해주세요.");
        return;
      }
    }

    openLayerFn($(".save-question-layer"));
  };

  const handleTypeChange = (cat, type) => {
    switch (cat) {
      case 1:
        setType1(type);
        break;
      case 2:
        setType2(type);
        // openAlertPopup("서비스 오픈 예정입니다.");
        break;
    }
    setChangeCount(changeCount + 1);
  };

  const callbackEvt = res => {
    if (res.command === "2100") {
      setGetData(res.data);
    }
    if (res.command === "2001") {
      setDeviceState(res.data);
    }
  };

  const settingDefaultData = () => {
    defaultYear = toDay.getFullYear();
    defaultMonth = toDay.getMonth() + 1;
    defaultDate = toDay.getDate();
    defaultHours = toDay.getHours();
    defaultMin = toDay.getMinutes();
    defaultDay = week[toDay.getDay()];
    defaultAmPm;

    if (defaultMonth < 10) {
      defaultMonth = "0" + defaultMonth;
    }

    if (defaultDate < 10) {
      defaultDate = "0" + defaultDate;
    }

    if (defaultHours < 10) {
      defaultHours = "0" + defaultHours;
    }

    if (defaultMin < 10) {
      defaultMin = "0" + defaultMin;
    }

    if (defaultHours < 12) {
      defaultAmPm = "오전";
    } else {
      defaultAmPm = "오후";
    }

    defaultValue =
      defaultMonth +
      "월" +
      " " +
      defaultDate +
      "일" +
      " " +
      defaultDay +
      " " +
      defaultAmPm +
      " " +
      defaultHours +
      ":" +
      defaultMin;

    setBsDate(defaultYear + "" + defaultMonth + "" + defaultDate);
    setBsTime(defaultHours + "" + defaultMin);
  };

  useEffect(() => {
    //주치의 메세지 닫기(확인버튼)
    $(".close-doctor-message").click(function () {
      closeLayerFn($(".doctor-message-layer"));
    });

    PostApi999(phonecfg, cfg, userinfo.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
          } else {
            openLayerFn($(".alert-layer-logout"));
            // dispatch({ type: LOG_OUT_SUCCESS });
            // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            //   login: "out",
            //   userToken: "",
            // });
          }
        }
      })
      .catch(err => {
        // openLayerFn($('.alert-layer-logout'));
        // dispatch({ type: LOG_OUT_SUCCESS });
        // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"out", "userToken":""});
        // openLayerFn($(".alert-layer-cnntFail"))
      });
  }, []);

  useEffect(() => {
    //닫기
    $(".save-question-layer .tbns-area a").click(function () {
      closeLayerFn($(".save-question-layer"));
    });

    //열기
    $(".aftermeal-picker-input").click(function () {
      var mealText = $(this).data("num");

      if (mealText == "1") {
        //식사 전
        $(".pickslide-after span.meal-txt").html("식사 전");
      } else if (mealText == "2") {
        //식사 후
        $(".pickslide-after span.meal-txt").html("식사 후");
      }

      openLayerFn($(".aftermeal-input-layer"));
      pickerStartFn2();
    });

    if (changeCount > 0 && $(".select-custom-box").length > 0) {
      $(".select-custom-box a.btn-select").click(function () {
        $(this).parent().toggleClass("on");
      });

      $(".select-custom-box ul li a").click(function () {
        $(this).closest(".select-custom-box").removeClass("on");
        $(this)
          .closest(".select-custom-box")
          .find("a.btn-select")
          .html($(this).html());
      });

      $("body").click(function (e) {
        if ($(".select-custom-box").hasClass("on")) {
          if (!$(".select-custom-box").has(e.target).length) {
            $(".select-custom-box").removeClass("on");
          }
        }
      });
    }

    ////확인 버튼 (선택한 기록을 저장하겠습니까? 레이어) //열기
    $(".open-savechecked").click(function () {
      openLayerFn($(".save-checked-layer"));
    });
    //닫기
    $(".save-checked-layer .tbns-area a").click(function () {
      closeLayerFn($(".save-checked-layer"));
    });

    setToDay(new Date());
  }, [type1, type2]);

  useEffect(() => {
    settingDefaultData();
  }, [toDay]);

  let bottom = null;
  if (type1 === TYPE1[0].code && type2 === TYPE2[1].code) {
    bottom = (
      <div className="under-fix-btnarea">
        <a className="btn-half-box clear">
          <i></i>선택해제
        </a>
        <a className="btn-half-box chsave open-savechecked">
          <i></i>선택저장
        </a>
      </div>
    );
  }

  return (
    <Fragment>
      <ScrollToTop />
      <Container Title={sub.label} bottom={bottom} goToUrl="/sm" color="green">
        <div className="contents sub">
          <SubMenu code={sub.code} />
          {type1 === TYPE1[0].code && type2 === TYPE2[0].code && (
            <BSInputManual
              type1={type1}
              type2={type2}
              onChangeType={handleTypeChange}
              setMealType={setMealType}
              setBs={setBs}
              setBsMemo={setBsMemo}
              checkValue={checkValue}
              defaultValue={defaultValue}
              setBsDate={setBsDate}
              setBsTime={setBsTime}
              setIsBuyBsDisplay={setIsBuyBsDisplay}
              bsDate={bsDate}
              bsTime={bsTime}
              setDisplay={setDisplay}
              dvcTitle={dvcTitle}
            />
          )}
          {type1 === TYPE1[0].code && type2 === TYPE2[1].code && (
            <BSInputAutomatic
              type1={type1}
              type2={type2}
              inputMode={inputMode}
              connection={connection}
              setConnection={setConnection}
              onChangeType={handleTypeChange}
              getData={getData}
              deviceState={deviceState}
              callbackEvt={callbackEvt}
            />
          )}
          {type1 === TYPE1[1].code && (
            <InsulinInput
              type1={type1}
              type2={type2}
              onChangeType={handleTypeChange}
              setMealType={setMealType}
              setInjctMemo={setInjctMemo}
              setInjctForm={setInjctForm}
              checkValue={checkValue}
              setInjctFormDesc={setInjctFormDesc}
              inputMode={inputMode}
              setInputMode={setInputMode}
              mealType={mealType}
              setBsDate={setBsDate}
              setBsTime={setBsTime}
              inputCnt={inputCnt}
              setInputCnt={setInputCnt}
              setInjctFormCstm={setInjctFormCstm}
              setInjctDoseCstm={setInjctDoseCstm}
              bsDate={bsDate}
              bsTime={bsTime}
            />
          )}
        </div>
      </Container>
      {isBuyBsDisplay && (
        <DeviceBsBuyLayer setIsBuyBsDisplay={setIsBuyBsDisplay} />
      )}
      {/* <DateTimeLayer setBpcDate={setBsDate} setBpcTime={setBsTime} type={type1}/> */}
      <WeekTimeLayer />
      <InputSaveLayer type1={type1} saveBs={saveBs} saveInjct={saveInjct} />
      <InputAutoSaveLayer />
      <AfterMealInputLayer setAfMealTime={setAfMealTime} />
      <InputDoctorMessageLayer />
      <MemoLayer />
      <LayerBox />
      <InsulinLayer setInjctForm={setInjctForm} setInjctDose={setInjctDose} />
      <InsulinInputLayer
        setInjctFormCstm={setInjctFormCstm}
        setInjctDoseCstm={setInjctDoseCstm}
      />
      <AlertPopup />
      {display && (
        <DvcInputLayer
          type={"BS"}
          typeNm={"혈당"}
          setIsDisplay={setDisplay}
          setDvcTitle={setDvcTitle}
        />
      )}
    </Fragment>
  );
};

const BSInputManual = props => {
  const {
    type1,
    type2,
    onChangeType,
    setMealType,
    setBs,
    setBsMemo,
    checkValue,
    defaultValue,
    setBsDate,
    setBsTime,
    setIsBuyBsDisplay,
    bsDate,
    bsTime,
  } = props;
  const { auth, userinfo, phonecfg, appStdInfo } = useContext(AppContext);
  const [display, setDisplay] = useState(false);
  const [dvcTitle, setDvcTitle] = useState("");

  const settingData = () => {
    setBs($("#bsValue").val());
    setBsMemo($("#bsMemo").val());
    if (!auth) _O.OpenMenu("/membership/login/3");
    else {
      if ($("#bsValue").val() === "") {
        openAlertPopup("측정한 혈당값을 넣어주세요.");
        return;
      }

      if (
        parseInt($("#bsValue").val()) < appStdInfo.bsMin ||
        parseInt($("#bsValue").val()) > appStdInfo.bsMax
      ) {
        openAlertPopup(
          "혈당수치는 " +
            appStdInfo.bsMin +
            "~" +
            appStdInfo.bsMax +
            "사이의 값을 넣으셔야 합니다."
        );
        return;
      }
      checkValue();
    }
  };

  const showAfInput = (e, type) => {
    $(".under-oninput.toggle").hide();
    if (type === "A") {
      $("#afTime").show();
    }
    setMealType(type);
  };

  const toggleAction = target => {
    $("#" + target).toggle();
    $("#" + target + "Plus").toggle();
    $("#" + target + "Minus").toggle();
  };

  const goStore = () => {
    setIsBuyBsDisplay(true);
    // NativeViewOpen(
    //   phonecfg.phoneOS,
    //   "https://smartstore.naver.com/mdpharmer/products/7721990241"
    // );
  };

  // 입력팝업.기기입력
  const [isDisplay, setIsDisplay] = useState(false);

  useEffect(() => {
    userHabit(phonecfg, "BS111");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  return (
    <div className="sub-contents">
      <div className="round-two-btns mtp">
        {TYPE1.map((item, i) => (
          <a
            href={void 0}
            key={i}
            className={cx({ on: item.code === type1 })}
            onClick={e => onChangeType && onChangeType(1, item.code)}>
            {item.label}
          </a>
        ))}
      </div>

      <div
        className="sub-title"
        style={{ padding: "20px 0px", paddingTop: "4px" }}>
        <div>
          {/* <img src={IC.bp.IC_BUY_ANIMATION} onClick={()=>goStore()} /> */}
          <AutoBs click={goStore} />
        </div>
      </div>

      {/* 목표혈당 START */}
      <div className="section-box">
        <TargetBs />
      </div>
      {/* 목표혈당 END */}

      <div className="section-box">
        <div className="sub-title">
          혈당
          {/* <div className="toggle-inputcheck">
                        <a href={void 0} className="off" onClick={(e) => onChangeType && onChangeType(2, TYPE2[1].code)}>
                            자동입력<i></i>수동입력
                        </a>
                    </div> */}
        </div>

        {/* <div className="device-state-info">아래의 정보를 입력해주세요.</div> */}

        <div className="full-input">
          <div className="inp-with-unit">
            {/* <input type="text" className="textbox fat num" id="inputHeartRate" style={{height:"46px"}}  placeholder="혈압 측정기 등록" /> */}
            {/* <DeviceInputLayer type={"BS"} typeNm={"혈당"} /> */}
            <DeviceInputLayer
              type={"BS"}
              typeNm={"혈당"}
              setIsDisplay={props.setDisplay}
              dvcTitle={props.dvcTitle}
            />
          </div>
        </div>

        <div className="meal-select-date">
          <div className="select-input">
            <div>
              <div className="select-custom-box bfaf-select">
                <a className="btn-select">식사 전</a>
                <ul>
                  <li>
                    <a onClick={e => showAfInput(e, "B")}>식사 전</a>
                  </li>
                  <li>
                    <a onClick={e => showAfInput(e, "A")}>식사 후</a>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              {/* <DateTimeLayer setBpcDate={setBsDate} setBpcTime={setBsTime} type={type1} /> */}
              <DateTimeLayer
                setBpcDate={setBsDate}
                setBpcTime={setBsTime}
                bpcTime={bsTime}
                bpcDate={bsDate}
              />

              {/* <input type="text" className="textbox datetime-picker-input pick-result" placeholder="날짜/시간을 선택해 주세요." defaultValue={defaultValue} readOnly /> */}
            </div>
          </div>
          <div className="under-oninput toggle" id="afTime">
            <input
              type="text"
              className="textbox aftermeal-picker-input pick-result2"
              data-num="2"
              placeholder="식후 시간을 선택해주세요. "
              readOnly
            />
          </div>
        </div>

        <div className="sub-tit-input">
          <div className="tit">혈당수치</div>
          <div className="inp-box">
            <input
              type="number"
              pattern="\d*"
              className="textbox"
              id="bsValue"
              placeholder="측정 혈당"
              onChange={e => maxLengthCheck(e, 3)}
            />
            <em>
              {!userinfo.app ||
              !userinfo.app.setInfo ||
              !userinfo.app.setInfo.bsUnit
                ? "mg/dl"
                : userinfo.app.setInfo.bsUnit}
            </em>
          </div>
        </div>
      </div>

      <div className="section-box">
        <div className="sub-title" onClick={() => toggleAction("etcBox")}>
          특이사항
          <img
            src={_ICON_PLUS}
            id="etcBoxPlus"
            style={{
              position: "absolute",
              width: "25px",
              marginLeft: "6px",
            }}
          />
          <img
            src={_ICON_MINUS}
            id="etcBoxMinus"
            style={{
              position: "absolute",
              width: "25px",
              marginLeft: "6px",
              display: "none",
            }}
          />
        </div>
        <div id="etcBox" style={{ display: "none" }}>
          <textarea
            className="textarea-box gray he1"
            id="bsMemo"
            style={{ resize: "none" }}
            maxLength="100"
            placeholder="특이사항 및 메모를 입력해주세요."
          />
        </div>
      </div>

      <div className="section-box">
        <div className="two-btns-area">
          <a onClick={() => _O.Open("/sm")}>취소</a>
          <a onClick={settingData} className="btn-aftersave">
            확인
          </a>
        </div>
      </div>
    </div>
  );
};

const BSInputAutomatic = props => {
  const {
    type1,
    type2,
    onChangeType,
    inputMode,
    connection,
    setConnection,
    getData,
    deviceState,
    callbackEvt,
  } = props;

  useEffect(() => {
    //메모 스케줄 리스트 상세 드롭다운
    $("a.btn-dropdown").click(function () {
      $(this).parent().toggleClass("on");
      $(this).next(".inthe-box").slideToggle("fast");

      if ($(this).parent().hasClass("on")) {
        var currentSctop = $(this).parent().offset().top - 20;
        $("html, body").stop().animate({ scrollTop: currentSctop }, 400);
      }
    });

    $("a.btn-closeup").click(function () {
      $(this).closest(".infobox").removeClass("on");
      $(this).closest(".infobox").find(".inthe-box").slideUp("fast");
    });

    //메모 버튼 클릭(레이어 열기)
    $(".btn-memo").click(function () {
      openLayerFn($(".memo-layer"));
    });
    //메모 레이어 닫기(취소, 확인 모두)
    $(".memo-layer .tbns-area a").click(function () {
      closeLayerFn($(".memo-layer"));
    });
  }, []);

  useEffect(() => {
    // socketManager(SocketCommand.BS_CONNECT, callbackEvt);
    console.log(getData);
  }, []);

  return (
    <div className="sub-contents">
      <div className="round-two-btns mtp">
        {TYPE1.map((item, i) => (
          <a
            href={void 0}
            key={i}
            className={cx({ on: item.code === type1 })}
            onClick={e => onChangeType && onChangeType(1, item.code)}>
            {item.label}
          </a>
        ))}
      </div>

      <div className="section-box">
        <div className="sub-title">
          혈당
          <div className="toggle-inputcheck">
            <a
              href={void 0}
              className=""
              onClick={e => onChangeType && onChangeType(2, TYPE2[0].code)}>
              자동입력<i></i>수동입력
            </a>
          </div>
        </div>
        <div className="device-state-info yellow">
          <i>!</i> 혈당측정기와 연결되었습니다.
        </div>

        <div className="allselect-box repad">
          <div className="check-dotguide">
            <label className="check-box">
              <input type="checkbox" />
              <i></i>전체선택
            </label>
          </div>
        </div>

        <div>
          <div className="section-box">
            <div className="date-title">2020. 08. 03. 월</div>
            <div className="time-schedule-list def">
              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오전
                      <br />
                      7:30
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a href={void 0} className="btn-dropdown">
                    <b>
                      146 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a href={void 0} className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a href={void 0} className="btn-select">
                          식사전
                        </a>
                        <ul>
                          <li>
                            <a href={void 0}>식사전</a>
                          </li>
                          <li>
                            <a href={void 0}>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a href={void 0} className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오후
                      <br />
                      12:00
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      190 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사전</a>
                        <ul>
                          <li>
                            <a>식사전</a>
                          </li>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <span>
                      오후
                      <br />
                      5:20
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      110 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>
                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사전</a>
                        <ul>
                          <li>
                            <a>식사전</a>
                          </li>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <span>
                      오후
                      <br />
                      8:30
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      200 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사후</a>
                        <ul>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-box">
            <div className="date-title">2020. 08. 03. 월</div>
            <div className="time-schedule-list def">
              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오전
                      <br />
                      7:30
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      146 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사전</a>
                        <ul>
                          <li>
                            <a>식사전</a>
                          </li>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오후
                      <br />
                      12:00
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      190 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사전</a>
                        <ul>
                          <li>
                            <a>식사전</a>
                          </li>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오후
                      <br />
                      5:20
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      110 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사전</a>
                        <ul>
                          <li>
                            <a>식사전</a>
                          </li>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="timebox">
                  <label className="check-box">
                    <input type="checkbox" />
                    <i></i>
                    <span>
                      오후
                      <br />
                      8:30
                    </span>
                  </label>
                </div>
                <div className="infobox def">
                  <a className="btn-dropdown">
                    <b>
                      200 <em>mg/dl</em>
                    </b>{" "}
                    식사전
                  </a>

                  <div className="inthe-box">
                    <a className="btn-closeup"></a>
                    <div>
                      <div className="select-custom-box">
                        <a className="btn-select">식사후</a>
                        <ul>
                          <li>
                            <a>식사후</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <input type="text" className="textbox" />
                    </div>
                    <div className="with">
                      <input type="text" className="textbox" />
                      <em>mg/dl</em>
                    </div>
                    <div className="text-area">
                      메모 작성한 내용이 노출됩니다. 메모 작성한 내용이
                      노출됩니다.
                    </div>
                    <div className="btn-me">
                      <a className="btn-memo">
                        <span>메모</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

let mediInvalueName;
let mediInvalueIUml;
let numberInvalue;

const InsulinInput = props => {
  // const [bsDate, setBsDate] = useState(defaultYear + '' + defaultMonth + '' + defaultDate);
  // const [bsTime, setBsTime] = useState(defaultHours + '' + defaultMin);
  const {
    type1,
    type2,
    onChangeType,
    setMealType,
    setInjctMemo,
    checkValue,
    setInjctFormDesc,
    inputMode,
    setInputMode,
    setBsDate,
    setBsTime,
    bsTime,
    bsDate,
  } = props;
  const { phonecfg } = useContext(AppContext);

  const [guideMode, setGuideMode] = useState("OFF");

  const setGuideModeFn = param => {
    setGuideMode(param);

    if (param === "ON") {
      userHabit(phonecfg, "BS113");
    } else {
      userHabit(phonecfg, "BS112");
    }
  };

  const openInputManual = () => {
    openLayerFn($(".insulin-set-layer"));
    pickerStartInsFn();
  };

  const openInputCustom = () => {
    openLayerFn($(".insulin-self-input-layer"));
    pickerOnInsFn();
  };

  const showAfInput = (e, type) => {
    $(".under-oninput.toggle").hide();
    if (type === "A") {
      $("#afTime").show();
    }
    setMealType(type);
  };

  const settingData = () => {
    setInjctMemo($("#injctMemo").val());

    if (inputMode === "CUSTOM") {
      setInjctFormDesc($("#setInjctFormDesc").val());
    }

    checkValue();
  };

  useEffect(() => {
    userHabit(phonecfg, "BS112");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  const inputFormControl = () => {
    if (props.inputCnt === 1) {
      props.setInputCnt(2);
    } else {
      props.setInputCnt(1);
    }
  };

  return (
    <div className="sub-contents">
      <div className="round-two-btns mtp">
        {TYPE1.map((item, i) => (
          <a
            key={i}
            className={cx({ on: item.code === type1 })}
            onClick={e => onChangeType && onChangeType(1, item.code)}>
            {item.label}
          </a>
        ))}
      </div>
      <div style={guideMode === "ON" ? { display: "none" } : { display: "" }}>
        <div className="section-box">
          {/* <div className="gray-btnbar">
            <a onClick={() => setGuideModeFn("ON")} className="">
              <i className="book"></i> 인슐린 가이드
            </a>
          </div> */}

          <div className="device-state-info">인슐린 투약량을 입력해주세요.</div>

          <div className="meal-select-date">
            <div className="select-input oneline">
              <div>
                <DateTimeLayer
                  setBpcDate={setBsDate}
                  setBpcTime={setBsTime}
                  bpcTime={bsTime}
                  bpcDate={bsDate}
                  type={type1}
                />
              </div>
              <div>
                <div className="select-custom-box bfaf-select">
                  <a className="btn-select">식사 전</a>
                  <ul>
                    <li>
                      <a onClick={e => showAfInput(e, "B")}>식사 전</a>
                    </li>
                    <li>
                      <a onClick={e => showAfInput(e, "A")}>식사 후</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="under-oninput toggle" id="afTime">
              <input
                type="text"
                className="textbox aftermeal-picker-input pick-result2"
                data-num="2"
                placeholder="식후 시간을 선택해주세요. "
                readOnly
              />
            </div>
          </div>

          <div className="section-box" style={{ marginTop: "15px" }}>
            <div className="sub-title" style={{ marginBottom: "8px" }}>
              인슐린 투약
            </div>
            <div style={{ color: "hsl(0deg 0% 61%)" }}>
              처방받으신 인슐린의 이름과 투약 용량을 입력하세요
            </div>

            <InputInsulin />
            {props.inputCnt === 2 && <InputInsulin />}

            <div style={{ textAlign: "center" }}>
              <img
                src={props.inputCnt === 1 ? _ICON_PLUS : ICON_MINUS_SRC}
                style={{
                  width: "25px",
                  marginTop: "10px",
                }}
                onClick={() => inputFormControl()}
              />
            </div>
          </div>
        </div>

        <div className="section-box">
          <div className="sub-title">특이사항</div>
          <div>
            <textarea
              className="textarea-box gray he1"
              id="injctMemo"
              placeholder="특이사항 및 메모를 입력해주세요."
              style={{ resize: "none" }}
            />
          </div>
        </div>

        <div className="section-box">
          <div className="two-btns-area">
            <a onClick={() => _O.Open("/sm")}>취소</a>
            <a onClick={settingData} className="btn-aftersave">
              확인
            </a>
          </div>
        </div>
      </div>

      <div style={guideMode === "OFF" ? { display: "none" } : { display: "" }}>
        <div className="section-box">
          <div className="gray-btnbar">
            <a onClick={() => setGuideModeFn("OFF")} className="dwn">
              <i className="book"></i> 인슐린 가이드
            </a>
          </div>

          <div className="sub-title" style={{ paddingTop: "15px" }}>
            인슐린 주사시 주의사항
          </div>
          <div className="nor-text">
            <ul>
              <li>혼합형, 중간형 주사법은 꼭 흔들어 사용해 주세요.</li>
              <li>인슐린 주사 후, 투여부의, 시간, 주사용량 등을 기록합니다.</li>
              <li>보통 성인의 경우 4-6mm의 주사바늘을 이용합니다.</li>
              <li>주사바늘은 1회 사용을 원칙으로 합니다.</li>
            </ul>
          </div>
        </div>

        <div className="section-box">
          <div className="sub-title">인슐린 투약방법</div>
          <div className="inguide-img">
            <img src={_INSULIN_GUIDE} alt="" />
            <p>출처 : 당뇨병 교육 간호사회</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const List = memo(props => {
  useTitle("자가건강관리_혈당_이력");
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);

  const [periodType, setPeriodType] = useState(
    parseInt(props.match.params.periodType)
  );
  const [startDate, setStartDate] = useState(
    props.match.params.startDate && props.match.params.startDate == "1"
      ? convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
      : props.match.params.startDate
  );
  const [endDate, setEndDate] = useState(
    props.match.params.endDate && props.match.params.endDate == "1"
      ? convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
      : props.match.params.endDate
  );

  const [list, setList] = useState("");
  const [checkedSeqNo, setCheckedSeqNo] = useState("");
  const [checkedInslSeqNo, setCheckedInslSeqNo] = useState("");

  const [trgtBsList, setTrgtBsList] = useState("");
  const [seqNo, setSeqNo] = useState("");
  const [memo, setMemo] = useState("");

  const [modifyDisplay, setModifyDisplay] = useState(false);
  const [modifyTarget, setModifyTarget] = useState("BS");
  const [targetData, setTargetData] = useState();

  const [deleteState, setDeleteState] = useState(false);
  const [isBuyBsDisplay, setIsBuyBsDisplay] = useState(false);

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
    reloadList();
  };

  const saveSeqNo = seqNo => {
    setSeqNo(seqNo);

    $("#targetKey").val(seqNo);
  };

  const request1205 = (
    userinfo,
    cfg,
    periodType,
    searchFromDt,
    searchToDt,
    pageNo,
    pageCnt
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1205(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        searchFromDt,
        searchToDt,
        pageNo,
        pageCnt
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setList(res);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      if (reqStartDate.length == 8 && reqEndDate.length == 8) {
        if (
          reqStartDate != "" &&
          reqEndDate != "" &&
          reqStartDate > reqEndDate
        ) {
          openAlertPopup("선택한 날짜를 확인하세요.");
        }
      }
    }
  };

  const request1208 = (userinfo, cfg) => {
    PostApi1208(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result != "") {
            setTrgtBsList(res.result);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const settingSeqNo = () => {
    let checkArr = new Array();
    let checkInslArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).val());
    });

    $("input[name=checkInslSeqNo]:checked").each(function () {
      checkInslArr.push($(this).val());
    });
    setCheckedSeqNo(checkArr);
    setCheckedInslSeqNo(checkInslArr);
  };

  // 전체 선택 기능 추가
  const checkedAll = () => {
    // 전체선택 해제
    // 모든 리스트가 선택된 경우
    if (
      $("input[name=checkSeqNo]:checked").length +
        $("input[name=checkInslSeqNo]:checked").length ===
      list.result.length
    ) {
      unCheckedAll();
    } else {
      $("input:checkbox").prop("checked", true);
      settingSeqNo();
    }
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  const reloadList = () => {
    if (periodType === 4) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1205(userinfo, cfg, periodType, startDate, endDate, 1, 500);
        unCheckedAll();
        setDeleteState(true);
      } else {
        setList("");
      }
    } else {
      request1205(userinfo, cfg, periodType, startDate, endDate, 1, 500);
      unCheckedAll();
      setDeleteState(true);
    }
  };

  const request1212 = (seqNo, mealType, afMealTime) => {
    PostApi1212(userinfo, cfg, phonecfg, seqNo, mealType, afMealTime)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result == 1) {
            // reloadList(seqNo);
            request1208(userinfo, cfg);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    reloadList();
  }, [periodType, startDate, endDate, trgtBsList, props.match.params]);

  useEffect(() => {
    if (checkedSeqNo == "" && checkedInslSeqNo == "") {
      $(".allcheck-setting-area").hide();
      $("input:checkbox").prop("checked", false);
    } else {
      if (
        list.result.length ===
        checkedSeqNo.length + checkedInslSeqNo.length
      ) {
        // $("input:checkbox").prop("checked", true);
        $("#checkboxAll").prop("checked", true);
      } else {
        $("#checkboxAll").prop("checked", false);
      }

      $(".allcheck-setting-area").show();
    }
  }, [checkedSeqNo, checkedInslSeqNo]);

  useEffect(() => {
    //기간설정 버튼들
    // $(".date-setting-area .btns a").click(function () {
    //   $(".date-setting-area .btns a").removeClass("on");
    //   $(this).addClass("on");
    //   var idx = $(this).index();
    //   if (idx == 3) {
    //     //직접 기간설정
    //     $(".date-setting-area .date-input").slideDown("fast");
    //   } else {
    //     $(".date-setting-area .date-input").slideUp("fast");
    //   }
    // });

    //목표혈압 버튼 (레이어 열기)
    $(".btn-goalset").click(function () {
      openLayerFn($(".bloodgoal-layer"));
      userHabit("BS100_P01");
    });
    //목표혈압 설정 레이어 닫기
    $(".bloodgoal-layer .tbns-area a").click(function () {
      closeLayerFn($(".bloodgoal-layer"));
    });

    //식단 이미지 클릭 (레이어 열기)
    $("a.btn-foodmenu").click(function () {
      openLayerFn($(".foodmenu-photo-layer"));
    });
    //식단 레이어 닫기
    $(".foodmenu-photo-layer .tbns-area a").click(function () {
      closeLayerFn($(".foodmenu-photo-layer"));
    });

    //선택삭제 버튼 클릭(삭제 확인 레이어 열기)
    $(".btn-check-delete").click(function () {
      openLayerFn($(".delete-confirm-layer"));
    });
    //삭제 확인 레이어 닫기
    $(".delete-confirm-layer .tbns-area a").click(function () {
      closeLayerFn($(".delete-confirm-layer"));
    });

    request1208(userinfo2, cfg);
  }, []);

  useEffect(() => {
    userHabit(phonecfg, "BS131");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  const Bottom = (
    <Fragment>
      <div className="allcheck-setting-area">
        <a onClick={unCheckedAll}>
          <i className="clear"></i>선택해제
        </a>
        <a href={void 0} className="btn-check-delete">
          <i className="dele"></i>선택삭제
        </a>
      </div>
      <div className="under-fixarea-emptybox"></div>
    </Fragment>
  );

  return (
    <Fragment>
      <Container
        Title="혈당 목록"
        bottom={Bottom}
        color="green"
        goToUrl={
          periodType === 4
            ? "/sm/bs" + "/" + periodType + "/" + startDate + "/" + endDate
            : "/sm/bs" + "/" + periodType + "/1/1"
        }>
        <div className="contents sub">
          <SubMenu code={SUBS[2].code} />
          <div className="sub-contents">
            <div className="section-box">
              <TargetBs />
            </div>
            <div className="date-setting-area" style={{ paddingTop: "20px" }}>
              <div className="btns">
                <a
                  onClick={() => setPeriodType(1)}
                  className={periodType == 1 ? "on" : ""}>
                  1주일
                </a>
                <a
                  onClick={() => setPeriodType(2)}
                  className={periodType == 2 ? "on" : ""}>
                  1개월
                </a>
                <a
                  onClick={() => setPeriodType(3)}
                  className={periodType == 3 ? "on" : ""}>
                  3개월
                </a>
                <a
                  onClick={() => setPeriodType(4)}
                  // className={
                  //   periodType == 4 ? "btn-selfinput on" : "btn-selfinput"
                  // }
                  className={`btn-selfinput ${periodType == 4 ? "on" : ""}`}>
                  {" "}
                  기간설정
                </a>
              </div>
              <div
                className="date-input"
                style={
                  periodType === 4 ? { display: "block" } : { display: "none" }
                }>
                <div className="round-bar">
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num1"
                      data-num="1"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        startDate.length == 8
                          ? startDate.substring(0, 4) +
                            "." +
                            startDate.substring(4, 6) +
                            "." +
                            startDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                  <u>~</u>
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num2"
                      data-num="2"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        endDate.length == 8
                          ? endDate.substring(0, 4) +
                            "." +
                            endDate.substring(4, 6) +
                            "." +
                            endDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                </div>
              </div>
            </div>
            {list != "" && (
              <SectionArea
                list={list}
                settingSeqNo={settingSeqNo}
                checkedAll={checkedAll}
                saveSeqNo={saveSeqNo}
                setMemo={setMemo}
                setModifyDisplay={setModifyDisplay}
                setSeqNo={setSeqNo}
                setModifyTarget={setModifyTarget}
                setTargetData={setTargetData}
                deleteState={deleteState}
                setDeleteState={setDeleteState}
              />
            )}
          </div>
        </div>
      </Container>
      {isBuyBsDisplay && (
        <DeviceBsBuyLayer setIsBuyBsDisplay={setIsBuyBsDisplay} />
      )}
      {/* <TargetBSLayer trgtBsList={trgtBsList} request1208={request1208} /> */}
      <MealDetailLayer />
      <MemoLayer
        seqNo={seqNo}
        memo={memo}
        request1208={request1208}
        modifyTarget={modifyTarget}
      />
      <AfterMealInputLayer2 evnetHandler={request1212} />
      <DeleteLayer
        checkedSeqNo={checkedSeqNo}
        checkedInslSeqNo={checkedInslSeqNo}
        periodType={periodType}
        startDate={startDate}
        endDate={endDate}
        reloadList={reloadList}
      />
      <DateLayer handleDate={handleDate} color="green" />
      <AlertPopup />
      {modifyDisplay && (
        <ModifyLayer
          modifyTarget={modifyTarget}
          targetData={targetData}
          seqNo={seqNo}
          modifyDisplay={modifyDisplay}
          setModifyDisplay={setModifyDisplay}
          reloadList={reloadList}
        />
      )}
    </Fragment>
  );
});

export const SectionArea = (props) => {
    const {
        list,
        settingSeqNo,
        checkedAll,
        saveSeqNo,
        setMemo,
        setModifyDisplay,
        setSeqNo,
        setModifyTarget,
        setTargetData,
        deleteState,
        setDeleteState,
    } = props;

    const openMemoPopup = (seqNo, memo) => {
        saveSeqNo(seqNo);
        setMemo(memo);
        openLayerFn($(".memo-layer"));
        // setModifyDisplay(true);
        $("#memoPopupValue").val(memo);
    };

    const openMealTypeLayer = (seqNo) => {
        saveSeqNo(seqNo);
        openLayerFn($(".aftermeal-input-layer"));
        pickerStartFn2();
    };

    useEffect(() => {
        //메모 버튼 클릭(레이어 열기)
        $(".btn-memo").click(function () {
            openLayerFn($(".memo-layer"));
        });

        //메모 레이어 닫기(취소, 확인 모두)
        $(".memo-layer .tbns-area a").click(function () {
            closeLayerFn($(".memo-layer"));
        });
    }, []);

    return (
      <Fragment>
        <div className="allselect-box">
          <div className="check-dotguide">
            <label className="check-box">
              <input type="checkbox" id="checkboxAll" onClick={checkedAll} />
              <i></i>전체선택
            </label>
          </div>
          <p>
            혈당상태는 의사와 상담후 입력한 목표 혈당수치를 기준으로 판단합니다.
            (목표혈당 미설정시 기준 : 식전 목표혈당 80~120 / 식후 목표혈당
            120~180)
          </p>
        </div>

        <div>
          {list != "" && (
            <SectionBox
              contentsList={list.result}
              settingSeqNo={settingSeqNo}
              openMealTypeLayer={openMealTypeLayer}
              openMemoPopup={openMemoPopup}
              setModifyDisplay={setModifyDisplay}
              setSeqNo={setSeqNo}
              setModifyTarget={setModifyTarget}
              setTargetData={setTargetData}
              deleteState={deleteState}
              setDeleteState={setDeleteState}
            />
          )}
        </div>
      </Fragment>
    );
};

const SectionBox = memo((props) => {
    const {
        contentsList,
        settingSeqNo,
        openMealTypeLayer,
        openMemoPopup,
        setModifyDisplay,
        setSeqNo,
        setModifyTarget,
        setTargetData,
        deleteState,
        setDeleteState,
    } = props;

    return (
        <Fragment>
            <div className="section-box">
                {/* <div className="date-title">
          {date1} {date2}
        </div> */}
                <SectionBoxList
                    contentsList={contentsList}
                    settingSeqNo={settingSeqNo}
                    openMealTypeLayer={openMealTypeLayer}
                    openMemoPopup={openMemoPopup}
                    setModifyDisplay={setModifyDisplay}
                    setSeqNo={setSeqNo}
                    setModifyTarget={setModifyTarget}
                    setTargetData={setTargetData}
                    deleteState={deleteState}
                    setDeleteState={setDeleteState}
                />
            </div>
        </Fragment>
    );
});

const SectionBoxList = memo((props) => {
    const {
        date,
        contentsList,
        settingSeqNo,
        openMealTypeLayer,
        openMemoPopup,
        setModifyDisplay,
        setSeqNo,
        setModifyTarget,
        setTargetData,
    } = props;
    const { phonecfg } = useContext(AppContext);

    const { ref, inView } = useInView();

    const [lastIndex, setLastIndex] = useState(1);
    const [displayList, setDisplayList] = useState([]);

    const AddListCount = 10;

    useEffect(() => {
        const viewList =
            contentsList &&
            Array.isArray(contentsList) &&
            contentsList.filter(
                (i, index) =>
                    index >= (lastIndex - 1) * AddListCount &&
                    index < lastIndex * AddListCount
            );

        if (props.deleteState) {
            setDisplayList(viewList);
            props.setDeleteState(false);
        } else {
            setDisplayList([...(displayList ?? []), ...(viewList ?? [])]);
        }
    }, [lastIndex, contentsList]);

    useEffect(() => {
        if (!contentsList || !Array.isArray(contentsList)) return;
        else if (inView && lastIndex * AddListCount < contentsList.length) {
            setLastIndex(lastIndex + 1);
        }
    }, [inView]);

    const openMemoBox = (i) => {
        $(i).parent().toggleClass("on");
        $(i).next(".inthe-box").slideToggle("fast");

        if ($(i).parent().hasClass("on")) {
            var currentSctop = $(i).parent().offset().top - 20;
            $("html, body").stop().animate({ scrollTop: currentSctop }, 500);
        }

        userHabit(phonecfg, "BS100_P01");
    };

    return (
        <div className="time-schedule-list mh">
            {contentsList.map((m, i) => (
                <Fragment key={i}>
                    {m.dataType === "BS" ? (
                        <BsHistList
                            m={m}
                            settingSeqNo={settingSeqNo}
                            openMemoPopup={openMemoPopup}
                            setModifyDisplay={setModifyDisplay}
                            setSeqNo={setSeqNo}
                            setModifyTarget={setModifyTarget}
                            setTargetData={setTargetData}
                            i={i}
                        />
                    ) : (
                        <IslnHistList
                            m={m}
                            settingSeqNo={settingSeqNo}
                            openMemoPopup={openMemoPopup}
                            setModifyDisplay={setModifyDisplay}
                            setSeqNo={setSeqNo}
                            setModifyTarget={setModifyTarget}
                            setTargetData={setTargetData}
                            i={i}
                        />
                    )}
                </Fragment>
            ))}
            {/* <div ref={ref} /> */}
        </div>
    );
});

const TargetBSLayer = (props) => {
    const { trgtBsList, request1208 } = props;
    const { userinfo, cfg, phonecfg } = useContext(AppContext);

    const request1207 = (userinfo, cfg, bfMaxBs, bfMinBs, afMasBs, afMinBs) => {
        PostApi1207(userinfo, cfg, phonecfg, bfMaxBs, bfMinBs, afMasBs, afMinBs)
            .then((res) => {
                if (res.resultMsg === "SUCCESS") {
                    // openAlertPopup("저장되었습니다.");
                    request1208(userinfo, cfg);
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const saveTrgtBs = () => {
        if (parseInt($("#bfMaxBs").val()) <= parseInt($("#bfMinBs").val())) {
            openAlertPopup("목표혈당값을 확인하세요.");
            return;
        }

        if (parseInt($("#afMaxBs").val()) <= parseInt($("#afMinBs").val())) {
            openAlertPopup("목표혈당값을 확인하세요.");
            return;
        }
        request1207(
            userinfo,
            cfg,
            $("#bfMaxBs").val(),
            $("#bfMinBs").val(),
            $("#afMaxBs").val(),
            $("#afMinBs").val()
        );
    };

    return (
        <div className="blacklayer-container bloodgoal-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">목표혈당 설정</div>
                        <div className="under-txt">
                            담당의사와 상담한 목표 혈당 수치입니다.
                        </div>

                        <div className="inlayer-input-halfbox2">
                            <p className="hf-tit">식전 목표혈당</p>
                            <div>
                                <div className="inp-with-unit fat">
                                    <input
                                        type="text"
                                        className="textbox fat num"
                                        id="bfMinBs"
                                        maxLength="3"
                                        defaultValue={trgtBsList.bfMinBs}
                                    />
                                    <i>
                                        {!userinfo.app ||
                                        !userinfo.app.setInfo ||
                                        !userinfo.app.setInfo.bsUnit
                                            ? "mg/dl"
                                            : userinfo.app.setInfo.bsUnit}
                                    </i>
                                </div>
                            </div>
                            <em>~</em>
                            <div>
                                <div className="inp-with-unit fat">
                                    <input
                                        type="text"
                                        className="textbox fat num"
                                        id="bfMaxBs"
                                        maxLength="3"
                                        defaultValue={trgtBsList.bfMaxBs}
                                    />
                                    <i>
                                        {!userinfo.app ||
                                        !userinfo.app.setInfo ||
                                        !userinfo.app.setInfo.bsUnit
                                            ? "mg/dl"
                                            : userinfo.app.setInfo.bsUnit}
                                    </i>
                                </div>
                            </div>
                        </div>

                        <div className="inlayer-input-halfbox2 btp">
                            <p className="hf-tit">식후 목표혈당</p>
                            <div>
                                <div className="inp-with-unit fat">
                                    <input
                                        type="text"
                                        className="textbox fat num"
                                        id="afMinBs"
                                        maxLength="3"
                                        defaultValue={trgtBsList.afMinBs}
                                    />
                                    <i>
                                        {!userinfo.app ||
                                        !userinfo.app.setInfo ||
                                        !userinfo.app.setInfo.bsUnit
                                            ? "mg/dl"
                                            : userinfo.app.setInfo.bsUnit}
                                    </i>
                                </div>
                            </div>
                            <em>~</em>
                            <div>
                                <div className="inp-with-unit fat">
                                    <input
                                        type="text"
                                        className="textbox fat num"
                                        id="afMaxBs"
                                        maxLength="3"
                                        defaultValue={trgtBsList.afMaxBs}
                                    />
                                    <i>
                                        {!userinfo.app ||
                                        !userinfo.app.setInfo ||
                                        !userinfo.app.setInfo.bsUnit
                                            ? "mg/dl"
                                            : userinfo.app.setInfo.bsUnit}
                                    </i>
                                </div>
                            </div>
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a onClick={saveTrgtBs} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const MealDetailLayer = (props) => {
    return (
        <div className="blacklayer-container foodmenu-photo-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box wht vertical">
                        <div className="blgr-title">식단</div>
                        <p className="under-txt">2020.08.02.아침식단</p>

                        <div className="food-photo-area">
                            <img src={_T_MEAL} alt="" />
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gree">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const MemoLayer = (props) => {
    const { seqNo, memo, request1208 } = props;
    const { userinfo, cfg, phonecfg } = useContext(AppContext);

    const request1209 = (userinfo, cfg, seqNo, bsMemo) => {
        //const {userinfo, cfg, phonecfg} = useContext(AppContext);
        PostApi1209(userinfo, cfg, phonecfg, seqNo, bsMemo)
            .then((res) => {
                if (res.resultMsg === "SUCCESS") {
                    // openAlertPopup("저장되었습니다.");
                    request1208(userinfo, cfg);
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const request1215 = (seqNo, bsMemo) => {
        PostApi1215(userinfo, cfg, phonecfg, seqNo, bsMemo)
            .then((res) => {
                if (res.resultMsg === "SUCCESS") {
                    // openAlertPopup("저장되었습니다.");
                    request1208(userinfo, cfg);
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="blacklayer-container memo-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">메모</div>

                        <div className="inlayer-memo-area">
                            <textarea
                                className="textarea-box"
                                placeholder="메모를 입력해 주세요."
                                id="memoPopupValue"
                            />
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a
                                onClick={() =>
                                    props.modifyTarget == "BS"
                                        ? request1209(
                                              userinfo,
                                              cfg,
                                              seqNo,
                                              $("#memoPopupValue").val()
                                          )
                                        : request1215(
                                              seqNo,
                                              $("#memoPopupValue").val()
                                          )
                                }
                                className="btn-round wht"
                            >
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const DeleteLayer = (props) => {
    const { userinfo, cfg, phonecfg } = useContext(AppContext);
    const {
        checkedSeqNo,
        checkedInslSeqNo,
        periodType,
        startDate,
        endDate,
        reloadList,
    } = props;

    const request1206 = (userinfo, cfg, bsSeqNo, inslSeqNo) => {
        PostApi1206(userinfo, cfg, phonecfg, bsSeqNo, inslSeqNo)
            .then((res) => {
                if (res.resultMsg === "SUCCESS") {
                    // 페이지 리스트 새로고침
                    reloadList(userinfo, cfg, periodType, startDate, endDate);
                } else {
                    console.log("LOGOUT!!!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="blacklayer-container delete-confirm-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">삭제</div>

                        <div className="delete-confirm-box">
                            <p>기록을 삭제 하겠습니까?</p>
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a
                                onClick={() =>
                                    request1206(
                                        userinfo,
                                        cfg,
                                        checkedSeqNo,
                                        checkedInslSeqNo
                                    )
                                }
                                className="btn-round wht"
                            >
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InputSaveLayer = (props) => {
    const { type1, saveBs, saveInjct } = props;
    return (
        <div className="blacklayer-container save-question-layer ">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">저장</div>

                        <div className="save-question-box">
                            {type1 === "BLOODSUGAR" ? "혈당" : "인슐린"}을 저장
                            하겠습니까?
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a
                                onClick={
                                    type1 === "BLOODSUGAR" ? saveBs : saveInjct
                                }
                                className="btn-round wht"
                            >
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InputAutoSaveLayer = (props) => {
    return (
        <div className="blacklayer-container save-checked-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">저장</div>

                        <div className="save-question-box">선택한 기록을 저장하겠습니까?</div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a href={void 0} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InputDoctorMessageLayer = (props) => {
    const { userinfo } = useContext(AppContext);
    return (
        <div className="blacklayer-container doctor-message-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">주치의 메세지</div>
                    <div className="doctor-message">
                        <div className="illust-circle">
                            <img src={Doctor.male.good} alt="" />
                        </div>
                        <div className="message-box">
                            {userinfo.userName} 님 아주 좋습니다.
                            <br />
                            오늘 하루 혈당관리도 기대하겠습니다.
                        </div>
                        <div className="btn-area">
                            <a onClick={()=> _O.Open("/sm/bs/list/3/1/1")} className="btn-round wht close-doctor-message">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InsulinInputLayer = (props) => {
    const {setInjctFormCstm, setInjctDoseCstm} = props;

    const setCustomInfo = () => {
        // 인슐린 이름 표시
        $(".gradation-box .in-txt span").html($("#setInjctFormDesc").val());
        $(".gradation-box .nums .center").html($(".onepick-slide .swiper-slide-active span").html());
        
        // 약 용량?? 처리
        if ($(".onepick-slide .swiper-slide-active span").html() === "15") {
            $("#prevCustom").html(14);
            $("#nextCustom").html(1);
        } else if($(".onepick-slide .swiper-slide-active span").html() === "1") {
            $("#prevCustom").html(15);
            $("#nextCustom").html(2);
        } else {
            $("#prevCustom").html(parseInt($(".onepick-slide .swiper-slide-active span").html()) - 1);
            $("#nextCustom").html(parseInt($(".onepick-slide .swiper-slide-active span").html()) + 1);
        }

        setInjctFormCstm("99");
        setInjctDoseCstm($(".onepick-slide .swiper-slide-active span").html());

        closeCustomPopup();
    }

    const closeCustomPopup = () => {
        pickerOneEndInsFn();
        closeLayerFn($(".insulin-self-input-layer"));
    }

    return (
        <div className="blacklayer-container insulin-self-input-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title undcap">인슐린 투약</div>
                        <div className="under-txt">투약 용량을 확인 한후 입력해 주세요.</div>

                        <div className="health-input-contain npad">
                            <div className="input-list">
                                <ul>
                                    <li>
                                        <div className="title">인슐린 이름</div>
                                        <div>
                                            <input type="text" id="setInjctFormDesc" placeholder="약 이름을 적어주세요." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title">인슐린 분량</div>
                                        <div className="one-side-pick">
                                            <div className="txt-line">
                                                <p>약 용량을 설정해 주세요.</p>
                                            </div>
                                            <div className="pick">
                                                <div className="picker-container">
                                                    <div className="swiper-container onepick-slide" id="pickerCustom">
                                                        <div className="swiper-wrapper">
                                                            <div className="swiper-slide">
                                                                <span>1</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>2</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>3</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>4</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>5</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>6</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>7</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>8</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>9</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>10</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>11</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>12</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>13</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>14</span>
                                                            </div>
                                                            <div className="swiper-slide">
                                                                <span>15</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="tbns-area">
                            <a onClick={closeCustomPopup} className="btn-round gray">
                                취소
                            </a>
                            <a onClick={setCustomInfo} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InsulinGuide = () => {
    return (
        <div className="blacklayer-container insulin-guide-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">주사위치 지정</div>
                    
                    <div className="insulin-guide-bgbox">
                        <div className="inguide-area">
                            <div>
                                <div className="hbox">
                                    <ul>
                                        <li><a>8/26</a></li>
                                        <li><a>8/27</a></li>
                                        <li><a>8/28</a></li>
                                        <li><a>8/29</a></li>
                                        <li><a className="on">9/1</a></li>
                                        <li><a>9/2</a></li>
                                        <li><a className="on">9/3</a></li>
                                        <li><a className="on">9/4</a></li>
                                        <li><a className="on">9/5</a></li>
                                        <li><a className="on">9/8</a></li>
                                        <li><a>9/10</a></li>
                                        <li><a className="on">9/11</a></li>
                                        <li><a className="on">9/12</a></li>
                                        <li><a className="on">9/13</a></li>
                                        <li><a className="on">9/14</a></li>
                                        <li><a>9/15</a></li>
                                    </ul>
                                    <p>오른쪽</p>
                                </div>
                                <div className="hbox">
                                    <ul>
                                        <li><a>8/30</a></li>
                                        <li><a>8/30</a></li>
                                        <li><a>8/30</a></li>
                                        <li><a>8/31</a></li>
                                        <li><a>9/3</a></li>
                                        <li><a>9/4</a></li>
                                        <li><a>9/5</a></li>
                                        <li><a>9/6</a></li>
                                        <li><a>9/11</a></li>
                                        <li><a>9/12</a></li>
                                        <li><a>9/13</a></li>
                                        <li><a>9/14</a></li>
                                        <li><a>10/10</a></li>
                                        <li><a>10/22</a></li>
                                        <li><a>10/12</a></li>
                                        <li><a>10/13</a></li>
                                    </ul>
                                    <p>왼쪽</p>
                                </div>
                            </div>
                        </div>
                        <div className="mark-info">
                            <p>
                                <span><i></i>투여한 부위</span>
                                <span><i className="wht"></i>투여 가능한 부위</span>
                            </p>
                        </div>
                    </div>

                    <div className="tbns-area">
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
}